import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5d4a2f5e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "../src/assets/style/reset.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "../src/assets/style/style.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports